export default function RequiredFieldLabel({ children, required = false }) {
  return (
    <span
      className={
        required
          ? "after:ml-0.5 after:text-danger after:content-['*']"
          : undefined
      }
    >
      {children}
    </span>
  );
}
